module.exports = __webpack_public_path__ + "img/review@3x.146e4b1c.png";